import React from 'react'
import { ContextMenu } from '@softura/fluentuipackage'
import './ContextMenu.scss'

interface IProps {
  className?: string|number,
  items?: any,
  hidden?: any,
  target?: any,
  onItemClick?: any,
  onDismiss?: any,
  children?: any,
  onClick?: any,
  ref?: any,
  href?: any
}
const ContextMenuContainer = ({
  className,
  children,
  ref,
  onClick,
  items,
  hidden,
  target,
  onItemClick,
  onDismiss,
  href
}:IProps) => {
  return (<>
    <a ref={ref} onClick={onClick} href={href}>
        {children}
    </a>
    <ContextMenu
      className = {`${className}`}
      items={items}
      hidden={!hidden}
      target={target}
      onItemClick={onItemClick}
      onDismiss={onDismiss}
     data-attribute="ContextMenu_Default_ContextMenu" />
  </>)
}

export default ContextMenuContainer
